/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import style from './index.module.scss';

const HomeStore = namespace('home');

@Component
export default class AdvMarketCard extends Vue {
  @Prop(Object) cardValidStyle!: Dictionary;

  @HomeStore.State marketSource!: string;

  @HomeStore.State marketHeight!: string;

  @HomeStore.State marketHasLoaded!: boolean;

  private render() {
    if (this.marketSource && this.marketHeight) {
      return (
        <div
          class={style.advMarketCard}
          style={this.marketSource ? this.cardValidStyle : {}}>
          <div
            class={style.rights}
            style={{
              backgroundImage: `url(${this.marketSource})`,
              height: `${this.marketHeight}`,
            }}
          />
        </div>
      );
    }

    return null;
  }
}
